import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerRootService } from '@se/se.ui.html5';
import { Observable, of } from 'rxjs';
import { BusinessUnit } from './models';
 
@Injectable({
    providedIn: 'root',
})

export class OrderBusinessUnitService extends ServerRootService {

    private readonly endPoint = '/RadiologyCommon/GetBusinessUnitsFromAll';
    private readonly url = this.getServerRoot() + this.endPoint;

    constructor(private httpClient: HttpClient) {
        super();
    }

    getBusinessUnitsFromAll(): Observable<Array<BusinessUnit>> {
        return this.httpClient.get<Array<BusinessUnit>>(this.url);
    }
}
